import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ApiError, fieldError, toApiError } from '../api/problem';
import { useI18n } from '../i18n/I18nProvider';
import { useAuth } from '../auth/AuthContext';

export function LoginPage() {
  const { login } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<ApiError | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setBusy(true);

    try {
      await login(email.trim(), password);

      const from = (location.state as { from?: string } | null)?.from;
      navigate(from ?? '/', { replace: true });
    } catch (caught) {
      setError(toApiError(caught));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-card">
      <h1 className="h4 mb-3">{t('auth.signIn.title')}</h1>

      {error && <div className="alert alert-danger py-2">{error.message}</div>}

      <form onSubmit={submit} noValidate>
        <div className="mb-3">
          <label className="form-label" htmlFor="login-email">
            {t('auth.email')}
          </label>
          <input
            id="login-email"
            type="email"
            autoComplete="username"
            className={`form-control ${fieldError(error, 'email') ? 'is-invalid' : ''}`}
            value={email}
            onChange={event => setEmail(event.target.value)}
            required
          />
          <div className="invalid-feedback">{fieldError(error, 'email')}</div>
        </div>

        <div className="mb-3">
          <label className="form-label" htmlFor="login-password">
            {t('auth.password')}
          </label>
          <input
            id="login-password"
            type="password"
            autoComplete="current-password"
            className={`form-control ${fieldError(error, 'password') ? 'is-invalid' : ''}`}
            value={password}
            onChange={event => setPassword(event.target.value)}
            required
          />
          <div className="invalid-feedback">{fieldError(error, 'password')}</div>
        </div>

        <button type="submit" className="btn btn-primary w-100" disabled={busy}>
          {busy ? t('auth.signIn.busy') : t('auth.signIn.title')}
        </button>
      </form>

      <p className="text-body-secondary small mt-3 mb-0">
        {t('auth.noAccount')} <Link to="/register">{t('auth.register')}</Link>
      </p>
    </div>
  );
}
